// @ts-ignore
Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
// @ts-ignore
Number.prototype.addLeadZero = function (text, length) {
  text = "" + text;
  while (text.length < length) {
    text = "0" + text;
  }
  return text;
};
export const DATES = [
  {
    name: "Aujourd'hui",
    code_text: "today",
    code_int: 0,
  },
  {
    name: "Demain",
    code_text: "tomorrow",
    code_int: 1,
  },
  {
    name: "Debut du mois en cours",
    code_text: "first_day_current_month",
    code_int: 2,
  },
  {
    name: "Fin du mois en cours",
    code_text: "last_day_current_month",
    code_int: 3,
  },
  {
    name: "Début du mois prochain",
    code_text: "first_day_next_month",
    code_int: 4,
  },
  {
    name: "Fin du mois prochain",
    code_text: "last_day_next_month",
    code_int: 5,
  },
  {
    name: "Après Demain",
    code_text: "after_tomorrow",
    code_int: 1,
  },
];

const CONSTANTS: any = {
  // Statuts des deals (affaires)
  DEAL_STATUS: {
    OPEN: "OPEN",
    WON: "win",
    LOST: "lost",
  },

  dateConstants: {
    today: () => new Date(),

    tomorrow: () => {
      const now = new Date();
      return new Date(now.setDate(now.getDate() + 1));
    },

    after_tomorrow: () => {
      const now = new Date();
      return new Date(now.setDate(now.getDate() + 2));
    },

    first_day_current_month: () => {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth(), 1);
    },

    /**
     * Periode glissante de 30 jours (bornes incluses), au format attendu par
     * vue2-daterange-picker. Sert de periode par defaut aux dashboards : le mois
     * calendaire en cours les laisse vides pendant ses premiers jours.
     */
    last_30_days: () => {
      const today = new Date();
      const end = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      const start = new Date(end.getFullYear(), end.getMonth(), end.getDate() - 29);
      return {startDate: start, endDate: end};
    },

    first_day: (date: Date) => {
      return new Date(date.getFullYear(), date.getMonth(), 1);
    },

    last_day_current_month: () => {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth() + 1, 0);
    },

    first_day_next_month: () => {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth() + 1, 1);
    },

    last_day_next_month: () => {
      const date = new Date();
      return new Date(date.getFullYear(), date.getMonth() + 2, 0);
    },

    last_day_current_year: () => {
      const date = new Date();
      return new Date(date.getFullYear(), 11, 31);
    },

    getLast7DaysInterval: () => {
      const today = new Date();
      const last7Days = new Date();
      last7Days.setDate(today.getDate() - 7);
      return { start: last7Days, end: today };
    },
  },
  modelPropertyTypes: {
    text: "text",
    number: "number",
    boolean: "boolean",
    object: "object",
    date: "date",
  },
  responseGroupStatus: {
    INCOMPLETE: "Incomplet",
    REACHABLE: "Joignable",
    COMPARED: "Comparé",
    OFFER_SELECTED: "Offre Sélectionnée",
    PAYMENT_INITIALIZED: "Paiement Initialisé",
    VALIDATED: "Gagné",
    EXPIRED: "Expiré",
    ABORTED: "Perdu",
  },
  responseGroupStatusColor: {
    INCOMPLETE: "#FFFFFF",
    REACHABLE: "#ffd160",
    COMPARED: "#fd7e14",
    OFFER_SELECTED: "#6610f2",
    PAYMENT_INITIALIZED: "#0DD1E3FF",
    VALIDATED: "#198754",
    EXPIRED: "#ce1b3d",
    ABORTED: "#ce1b3d",
  },
  fileExtensions: [],
  todoTypes: [
    "CONTACT_CUSTOMER",
    "QUALIFY_CUSTOMER",
    "SEND_CUSTOMER_OFFER",
    "CLOSE_QUOTE",
    "CUSTOM",
  ],
  CONTRACT_STATUS: {
    QUOTATION: "DEVIS",
    ONGOING: "EN_COURS",
    EXPIRED: "EXPIRE",
    CANCELLED: "RESILIE",
    PAUSED: "SUSPENDU",
    WAITING: "EN_ATTENTE",
    RENEW: "RENOUVELLE",
  },
  AVENANT_STATUS: {
    PROJET: "PROJET",
    VALIDE: "VALIDE",
    EN_COURS: "EN_COURS",
    EXPIRED: "EXPIRE",
  },
  PAYMENT_STATUS: {
    PENDING: "En Attente",
    FAILED: "Echouée",
    SUCCEED: "Réussie",
    CANCELLED: "Annulée",
  },
  orderStatus: {
    CREATED: "Crée",
    WAITING: "En attente",
    FAILED: "Echoué",
    PAYED: "Payé",
    EXPIRED: "Expiré",
  },
  orderStatusCode: {
    CREATED: "CREATED",
    WAITING: "WAITING",
    FAILED: "FAILED",
    PAYED: "PAYED",
    EXPIRED: "EXPIRED",
  },
  statusConversation: [
    { value: "IN_PROGESS", text: "En cours" },
    { value: "WAITING", text: "En attente" },
    { value: "SUCCESS", text: "Succès" },
    { value: "REOPEN", text: "Re-ouvert" },
    { value: "AVOIDABLE", text: "Á evité" },
  ],
};
export const WORKFLOWS = {
  ASACI: "attestation_digitale_automobile",
};

export default CONSTANTS;
